import React, { useEffect, useState } from 'react';
import { Button, Grid } from '@material-ui/core';

import SharedTitle from './SharedForms/SharedTitle';

import { CORP_BLUE, DESC_CARGA_EQUIPAMIENTO, } from 'config/config';
import { toast, CustomToast } from '@jumbo/components/custom/Toast';
import { deleteEquipoFromFicha, downloadEquipMasivoXls, getAllCodEquip, getAutoridadesPorRegion, getEquipoPorFicha, getServiciosMed, postSingleEq, subirCargaMasivaEquipFt } from 'services/api';
import Spinner from '@jumbo/components/custom/Spinner';
import DataTable from '@jumbo/components/EqCustomTable';
import ModalCargaEquipamiento from './ModalCargaEquipamiento';
import { useLocation } from 'react-router-dom';

import CloudDownloadOutlinedIcon from '@material-ui/icons/CloudDownloadOutlined';
import CloudUploadOutlinedIcon from '@material-ui/icons/CloudUploadOutlined';
import { AddBoxOutlined } from '@material-ui/icons';

import { getCodEquipByService } from 'services/api';

const headCells = [
    { id: 'codigo', label: 'ID', type: 'text', shown: true },
    { id: 'nom_equipo', label: 'Nombre equipo', type: 'text', shown: true },
    { id: 'marca', label: 'Marca', type: 'text', shown: true },
    { id: 'modelo', label: 'Modelo', type: 'text', shown: true },

]

const CargaEquipamiento = props => {


    const [openView, setOpenView] = useState(false)
    const [reload, setReload] = useState(false)
    const [loading, setIsLoading] = useState(false)
    const [filas, setFilas] = useState([])
    const [openModalCrear, setOpenModalCrear] = useState(false)
    const [optionsEquipamiento, setOptionsEquipamiento] = useState([])
    const [titulo, setTitulo] = useState('Cargando...')
    const location = useLocation();
    const [autoridadesAux, setAutoridadesAux] = useState([/* { value: 0, label: 'Seleccione' }, */])

    const closeModalCrear = () => {
        setOpenModalCrear(false)
    }

    const closeView = () => {
        setOpenView(false)
    }

    const reloadTble = () => {
        setReload(!reload)
    }


    const handleDelete = (data) => {
        setIsLoading(true)
        deleteEquipoFromFicha(sessionStorage.getItem("idFicha"), data.id)
            .then(res => {
                toast.success("Registro eliminado correctamente.")
                reloadTble()
            })
            .catch(e => {
                console.error(e)
                console.error("Error al eliminar registro")
            })
            .finally(f => {
                setIsLoading(false)
                reloadTble()
            })

    }

    const handleSave = (data) => {

    }

    useEffect(() => {
        /*         getAllCodEquip()
                    .then(res => {
                        setOptionsEquipamiento(res.data)
                    })
                    .catch(e => console.error(e))
                    .finally(f => {
        
                    }) */


        if (autoridadesAux.length === 0) {
            getAutoridadesPorRegion(sessionStorage.getItem('region'))
                .then(res => {
                    let aux = res.data.map(item => ({
                        value: item.id,
                        label: item.nombre
                    }));
                    //setAutoridadesAux([{ value: 0, label: 'Seleccione' }, ...aux])
                    setAutoridadesAux(aux)
                })
                .catch(e => console.error(e))
                .finally(f => {

                })
        }

        //getCodEquipByService(sessionStorage.getItem("idNav"))
            getAllCodEquip()
            .then(res => {
                setOptionsEquipamiento(res.data)
            })
            .catch(e => console.error(e))
            .finally(f => {

            })
        setIsLoading(true)
        getEquipoPorFicha(sessionStorage.getItem("idFicha"))
            .then(res => {

                let aux = res.data.map((item, index) => {

                    return {
                        ...item,
                        codigo: item.cod_equipamiento.codigo,
                        nom_equipo: item.cod_equipamiento.descripcion,
                        id_tipo_servicio:item.id_tipo_servicio ? item.id_tipo_servicio.toUpperCase() : item.id_tipo_servicio,
                        garantia_vigente: item.garantia_vigente === true ? 'SI' : 'NO'

                    }
                })

                setFilas(aux)
            })
            .catch(e => console.error(e))
            .finally(f => {
                //setIsLoading(false)
                getServiciosMed(sessionStorage.getItem('idNav'))
                    .then((res) => {
                        setTitulo(res.data.nombre)

                        //setInstalacionesList(ordenarArregloAlfabeticamente(res.data.equipamiento) || [])
                    })
                    .catch(e => console.error(e))
                    .finally(f => {
                        setIsLoading(false)
                    })
            })
    }, [reload])

    const postCargaMasivaEq = (data) => {
        setIsLoading(true);

        subirCargaMasivaEquipFt(data, sessionStorage.getItem("idFicha"), {
            responseType: "blob"
        })
            .then(async (res) => {

                let contentType = res.headers['content-type'];

                // Caso 1: Vino JSON → todo OK
                if (contentType && contentType.includes("application/json")) {
                    const json = await res.data.text();
                    const parsed = JSON.parse(json);

                    if (parsed.registros_fallidos > 0) {
                        toast.warn(`Carga completa con advertencias: ${parsed.registros_fallidos} fallos`);
                    } else {
                        toast.success("Archivo subido correctamente.");
                    }

                } else if (contentType && contentType.includes("text/plain")) {

                    toast.warn("Algunos registros fallaron. Descargando detalle...");

                    const blob = new Blob([res.data], { type: "text/plain" });
                    const url = window.URL.createObjectURL(blob);

                    const a = document.createElement("a");
                    a.href = url;

                    const disposition = res.headers['content-disposition'];
                    let filename = "errores_carga.txt";
                    if (disposition) {
                        const match = disposition.match(/filename="([^"]+)"/);
                        if (match && match[1]) filename = match[1];
                    }

                    a.download = filename;
                    a.click();
                    window.URL.revokeObjectURL(url);
                }
            })
            .catch((e) => {
                toast.error("Error cargando archivo.");
                console.error(e);
            })
            .finally(() => {
                setIsLoading(false)
                setReload(!reload)
            });
    };

    /*     useEffect(() => {
            setIsLoading(true)
    
            getServiciosMed(sessionStorage.getItem('idNav'))
                .then((res) => {
                    setTitulo(res.data.nombre)
    
                    //setInstalacionesList(ordenarArregloAlfabeticamente(res.data.equipamiento) || [])
                })
                .catch(e => console.error(e))
                .finally(f => {
                    setIsLoading(false)
                })
    
            //eslint-disable-next-line react-hooks/exhaustive-deps
        }, [location]) */



    const changeSingleFile = e => {

        let auxFile = e.target.files[0];
        //    const fileMb = auxFile.size / 1024 ** 2;

        if (auxFile.name === 'carga_masiva_equipamiento_fichas_tecnicas.xlsx') {
            setIsLoading(true)
            let bodyFormData = new FormData();
            bodyFormData.append('file', auxFile)
            postCargaMasivaEq(bodyFormData)

        } else {
            toast.error('El archivo debe ser "carga_masiva_equipamiento_fichas_tecnicas.xlsx".');
        }

    };

    const descargarPlantilla = () => {
        downloadEquipMasivoXls()
            .then(res => {
                const blob = new Blob([res.data]);
                const downloadUrl = URL.createObjectURL(blob);
                const filename = 'carga_masiva_equipamiento_fichas_tecnicas.xlsx';
                const anchor = document.createElement('a');
                anchor.href = downloadUrl;
                anchor.download = filename;
                document.body.appendChild(anchor);
                anchor.click();
                anchor.remove();
                URL.revokeObjectURL(downloadUrl);
            })
            .catch(e => console.error(e))
            .finally(f => {

            })
    }

    const postSingleEqe = (data) => {
        let aux = {
            ...data,
            garantia_vigente: data.garantia_vigente ? (data.garantia_vigente === "SI" ? true : false) : null
        }
        setIsLoading(true)
        postSingleEq(aux, sessionStorage.getItem("idFicha"))
            .then(res => {
                reloadTble()
            })
            .catch(e => console.error(e))
            .finally(f => {
                setIsLoading(false)
            })
        console.log(data)
    }

    return (
        <>
            <CustomToast />
            {loading ?
                <Spinner show={loading} />
                :
                null
            }
            <div style={{ width: '100%', flexBasis: '100%', backgroundColor: 'white' }}>
                <ModalCargaEquipamiento
                    openDialog={openModalCrear}
                    close={closeModalCrear}
                    optionsEquipamiento={optionsEquipamiento}
                    postData={postSingleEqe}
                    autoridades={autoridadesAux}
                />
                <SharedTitle
                    title={titulo}
                />
                <Grid item xs={12} sm={12} md={12} style={{ paddingTop: 15, paddingBottom: 15, paddingRight: 25, paddingLeft: 25 }}>
                    <p>{DESC_CARGA_EQUIPAMIENTO}</p>
                </Grid>
                <Grid container justifyContent='flex-start' item xs={12} style={{ marginBottom: 10, paddingRight: 25, paddingLeft: 25 }}>
                    <Grid container item xs={12} spacing={4}>

                        <Button
                            startIcon={<AddBoxOutlined />}
                            style={{ margin: 5 }}
                            variant='outlined'
                            color='primary'
                            onClick={() => {
                                setOpenModalCrear(true)
                            }}
                        >
                            Agregar
                        </Button>
{/*                         <Button
                            style={{ margin: 5 }}
                            variant='outlined'
                            color='primary'
                            disabled={loading}
                            onClick={() => { descargarPlantilla() }}
                            startIcon={<CloudDownloadOutlinedIcon />}
                        >
                            Descargar plantilla
                        </Button>

                        <Button
                            startIcon={<CloudUploadOutlinedIcon />}
                            disabled={loading}
                            style={{
                                margin: 5,
                                color: "#2e7d32",
                                borderColor: "#2e7d32"
                            }}
                            variant='outlined'

                            onClick={() => { }}
                        >
                            <input
                                accept=".xlsx"
                                id="contained-button-file-input"
                                type="file"
                                onChange={e => changeSingleFile(e)}
                                hidden
                            />
                            <label
                                htmlFor="contained-button-file-input"
                                style={{
                                    position: 'absolute',
                                    top: 0,
                                    left: 0,
                                    right: 0,
                                    bottom: 0,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    cursor: 'pointer',
                                    width: '100%',
                                    height: '100%',
                                }}
                            ></label>
                            Cargar equipamiento
                        </Button> */}


                    </Grid>
                </Grid>
                {
                    filas.length > 0 ?
                        <Grid container justifyContent='flex-start' item xs={12} style={{ marginBottom: 10, paddingRight: 25, paddingLeft: 25 }}>
                            <DataTable
                                headCells={headCells}
                                rows={filas}
                                handleSave={handleSave}
                                handleDelete={handleDelete}
                                reloadTable={reloadTble}
                                autoridades={autoridadesAux}
                            />
                        </Grid>
                        :
                        null
                }
            </div>
            {/*<GuardarYSalirBtn />*/}

        </>
    );
};

export default CargaEquipamiento;
